<template>
  <el-dialog title="置顶设置" :visible.sync="topSetVisible" width="400px">
    <el-form :model="topSetParam" ref="topSetForm" :rules="topSetRules" label-width="80px">
      <el-form-item label="置顶：" prop="homePageTopFlag">
        <el-radio-group v-model="topSetParam.homePageTopFlag">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="topSetParam.homePageTopFlag === 1" label="样式：" prop="topStyle">
        <el-radio-group v-model="topSetParam.topStyle">
          <el-radio :label="2">仅标题</el-radio>
          <el-radio :label="1">文章样式</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
          <el-button @click="topSetVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmTopSet">确认</el-button>
      </span>
  </el-dialog>
</template>

<script>
import {changeHomePageTop} from "@/api/saas/package";

export default {
  name: "TopSetDialog",
  components: {},
  props: {},
  data () {
    return {
      topSetVisible: false,
      topSetParam: {
        articleId: null,
        homePageTopFlag: null,
        topStyle: null
      },
      topSetRules: {
        homePageTopFlag: [
          {required: true, message: '请选择是否置顶', trigger: 'change'}
        ],
        topStyle: [
          {required: true, message: '请选择置顶样式', trigger: 'change'}
        ],
      }
    };
  },
  computed: {},
  watch: {},
  created () {
  },
  methods: {
    showTopSet (row) {
      this.topSetParam.articleId = row.articleId
      this.topSetParam.homePageTopFlag = row.homePageTopFlag
      this.topSetParam.topStyle = row.topStyle
      this.topSetVisible = true
    },
    confirmTopSet () {
      changeHomePageTop(this.topSetParam)
        .then(response => {
          this.msgSuccess('操作成功')
          this.topSetVisible = false
          this.$emit('success')
        })
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
